import { batch, store } from "react-recollect";
import { ButtonPrimary } from "./Buttons";
import { LoginIcon } from "@heroicons/react/outline";
import { useRef, useState } from "react";
import Input from "./Input";
import { certPOSTj } from "lib/API";
import Spinner from "./Spinner";
import { tryToLoadToken } from "./Login";

export function LoginForm() {
  const [loggingIn, setLoggingIn] = useState(false);
  const [user, setUser] = useState(window.localStorage.getItem("user") || "");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const passwordRef = useRef();

  async function login() {
    setLoggingIn(true);

    const result = await certPOSTj("login", { user, pass });

    if (!result || !result.token) {
      setError("Invalid username or password");
      setTimeout(() => setLoggingIn(false), 1000);
    } else {
      const tokenInfo = tryToLoadToken(result.token);
      batch(() => {
        store.token = tokenInfo.token;
        store.loggedInUser = tokenInfo.loggedInUser;
        window.localStorage.setItem("token", tokenInfo.token);
      });
    }
  }
  return (
    <div className="border-2 border-slate-900 shadow-lg p-4 m-auto bg-slate-600 w-96">
      {error && (
        <p className="bg-red-900 border-2 border-red-500 p-2 shadow-md shadow-red-700 mb-4">
          {error}
        </p>
      )}
      <Input
        labelClassName="text-white"
        label="username / email"
        value={user}
        setValue={setUser}
        disabled={loggingIn}
        onEnter={pass.length > 0 ? login : passwordRef?.current?.focus}
      />
      <Input
        labelClassName="text-white"
        label="password"
        type="password"
        value={pass}
        setValue={setPass}
        disabled={loggingIn}
        onEnter={login}
        ref={passwordRef}
      />
      <div className="btn-group float-right mt-4">
        <ButtonPrimary onClick={login} disabled={loggingIn}>
          {loggingIn ? <Spinner /> : <LoginIcon className="mr-2 size-6" />}
          Log in
        </ButtonPrimary>
      </div>
    </div>
  );
}
